module.exports = __webpack_public_path__ + "img/saturn4.550cc3dc.png";